import React, { useState } from 'react'

// query
import { useMutation } from '@apollo/client'
import { BULK_CREATE_INVENTORY_RECEIVING_LOG } from '../../../../graphql/inventoryReceivingLog/inventoryReceivingLog.mutations'
import { GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS, GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS, GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'
import { apolloClient } from '../../../..'

// components
import SideViewModal from '../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import PurchaseOrderDetailReceivingForm from '../PurchaseOrderDetailReceving.form'
// utils
import { createSubmitData } from '../../../inventory/InventoryDashboard/forms/ReceivingLog/ReceivingLog.form.controller.utils'
import { validate } from '../../../../shared/utility'

const validationSchema = {
    date: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    },
    time: {
        type: 'time',
        validation: {
            required: true,
            isTime: true
        }
    },
    fromPurchaseOrder: {
        type: 'input',
        validation: { required: true }
    },
    equipment: {
        type: 'list',
        fields: {
            quantityReceived: {
                type: 'input',
                validation: {
                    required: true
                }
            }
        }
    }
}

export default function PurchaseOrderDetailReceivingFormController({ visible, closeForm, id }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [purchaseOrder, setPurchaseOrder] = useState(null)
    const [createReceivingLog, {}] = useMutation(BULK_CREATE_INVENTORY_RECEIVING_LOG)
    const [errors, setErrors] = useState({ equipment: []})

    // handle the form submission
    const handleSubmit = (finalData) => {
        const { isValid, errors } = validate(finalData, validationSchema)

        if(isValid) {
            const submitData = createSubmitData(finalData)
            createReceivingLog({ variables: {...submitData}, refetchQueries:[GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS, GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS]}).catch(e => {
            }).then(result => {
                if(result) {
                    setErrors({ equipment: [] })
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
        
    }

    if(visible && isFetchingObject) {

        // fetch the data
        apolloClient.query({ query: GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM, variables: { id }}).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                setPurchaseOrder({...result.data.equipmentPurchaseOrder })
                setIsFetchingObject(false)
            }
        })

        return (null)
    }

    else if(visible && !isFetchingObject && purchaseOrder) {
        const variants = [
            {
                name: 'Receiving Purchase Order',
                component: <PurchaseOrderDetailReceivingForm />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Complete Receiving'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: [] })
                closeForm()
            }} 
            title='Receiving Purchase Order'
            variants={variants}    
            prefillData={purchaseOrder}
            errors={errors}
        />)
    }

    return null
}